<template lang="pug">
.content.flex.flex-wrap.justify-center.h-full

  .icon.m-1.p-2.border.flex.flex-col.rounded.text-blue-600(v-for="item in items")
    Icon(:item="item.icon" size="md")
    .label {{ item.name }}

</template>

<script>

import Resource from '@/components/Resource'

import { resources } from '@/engine/BoardManagerAdapter.js'
// Icons are now managed via @vortex/engine

export default {
  name: 'Elements',
  components: { Resource },
  data: () => ({
    items: [
      ...resources,

      // ...icons.map(x => ({ name: `icon: ${x}`, icon: x })),
    ]
  })
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/elements.vue